import _ from 'underscore'
import Vue from 'vue'

export default {

	namespaced: true,

	state: {

		session: false,
		data: {}

	},

	getters: {

		key: function(state) {

			return state.data.session

		},

		notifications: function(state) {

			return state.data.notifications

		},

		notification: function(state) {

			return state.data.notification

		},

		upgraded: function(state) {

			return (state.data.user) ? state.data.user.upgraded : false

		},

		patreon: function(state) {

			return (state.data.user) ? state.data.user.patreon : false

		},

		early: function(state) {

			return (state.data.user) ? state.data.user.early : []

		},

		loggedin: function(state) {

			return state.data.user

		},

		recent: function(state) {

			return (state.data.recent) ? state.data.recent.slice(0, 10) : []

		},

		groups: function(state) {

			return (state.data.groups) ? state.data.groups : []

		},

		'user/slug': function(state) {

			return (state.data.user) ? state.data.user.slug : false

		},

		'user/name': function(state) {

			return (state.data.user) ? state.data.user.name : false

		},

		'user/perks': function(state) {

			return (state.data.user) ? state.data.user.perks : false

		},

		'user/id': function(state) {

			return (state.data.user) ? state.data.user.id : false

		},

		'user/date': function(state) {

			return (state.data.user) ? state.data.user.date : {}

		},

		'user/date/sync': function(state) {

			return (state.data.user) ? state.data.user.date.sync : {}

		},

		'user/date/sync/next': function(state) {

			return (state.data.user) ? state.data.user.date.nextSync : {}

		},

		'user/date/sync/deep': function(state) {

			return (state.data.user) ? state.data.user.date.syncDeep : false

		},

		'user/date/sync/full': function(state) {

			return (state.data.user) ? state.data.user.date.syncFull : false

		},

		'user/date/sync/first': function(state) {

			return (state.data.user) ? state.data.user.date.syncFirst : false

		},

		'user/date/upgraded': function(state) {

			return (state.data.user) ? state.data.user.date.upgraded : false

		},

		'user/date/registered': function(state) {

			return (state.data.user) ? state.data.user.date.registered : false

		},

		'user/date/sync/standard': function(state) {

			return (state.data.user) ? state.data.user.date.syncStandard : false

		},

		'user/sync/type': function(state) {

			return (state.data.user) ? state.data.user.syncType : {}

		},

		user: function(state) {

			return (state.data.user) ? state.data.user : {}

		}

	},

	mutations: {

		group: function(state, data) {

			_.each(state.data.groups, function(group, index) {

				if (group.id === data.id) {

					Vue.set(state.data.groups, index, data)

				}

			})

		},

		set: function(state, data) {

			state.data = data || {}

		},

		notification: function(state, value) {

			state.data.notification = value

		},

		notifications: function(state, value) {

			state.data.notifications = value

		},

		'early': function(state, data) {

			Vue.set(state.data.user, 'early', data)

		},

		'user/hindex': function(state, data) {

			Vue.set(state.data, 'hindex', data)

		},

		'user/update': function(state, data) {

			state.data.user = data

		},

		'groups/add': function(state, data) {

			state.data.groups = _.filter(state.data.groups, function(item) { return item.id !== data.id })

			state.data.groups.push(data)

			state.data.groups = _.sortBy(state.data.groups, function(group) {

				return group.name.toLowerCase()

			})

			state.data.user.count.groups = state.data.groups.length

		},

		'groups/remove': function(state, id) {

			state.data.groups = _.filter(state.data.groups, function(item) { return item.id !== id })

			state.data.user.count.groups = state.data.groups.length

		},

		'recent/add': function(state, data) {

			state.data.recent = _.filter(state.data.recent, function(item) { return !_.isEqual(item, data) })

			state.data.recent.unshift(data)

		},

		'recent/remove': function(state, data) {

			state.data.recent = _.filter(state.data.recent, function(item) { return item.slug !== data.slug || item.type !== data.type })

		},

		'user/sync/type': function(state, data) {

			state.data.user.syncType = data

		}

	},

	actions: {

		verify: function() {

		}

	}

}